(function () {
  var SELECTORS = {
    body: '.main-article__body',
    tocList: '.main-article__toc-list',
    tocWidget: '.main-article__toc',
    tocToggle: '.main-article__toc-toggle'
  };

  var HEADING_TAGS = ['H2', 'H3', 'H4'];

  function slugify(text) {
    return text
      .toString()
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-')
      .replace(/[^\w\u00C0-\u024F\u0400-\u04FF-]/g, '')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function buildToc() {
    var articleBody = document.querySelector(SELECTORS.body);
    var tocList = document.querySelector(SELECTORS.tocList);
    var tocWidget = document.querySelector(SELECTORS.tocWidget);

    if (!articleBody || !tocList || !tocWidget) return;

    var headings = articleBody.querySelectorAll(HEADING_TAGS.join(','));
    if (headings.length < 2) {
      tocWidget.style.display = 'none';
      return;
    }

    /* Assign IDs and collect heading data */
    var items = [];
    var usedIds = {};

    for (var i = 0; i < headings.length; i++) {
      var heading = headings[i];
      var text = heading.textContent.trim();
      if (!text) continue;

      var id = heading.id || slugify(text);
      /* Ensure unique ID */
      if (usedIds[id]) {
        var count = 2;
        while (usedIds[id + '-' + count]) count++;
        id = id + '-' + count;
      }
      usedIds[id] = true;
      heading.id = id;

      var level = parseInt(heading.tagName.charAt(1), 10); /* 2, 3, or 4 */
      items.push({ id: id, text: text, level: level, el: heading });
    }

    if (items.length === 0) {
      tocWidget.style.display = 'none';
      return;
    }

    /* Build hierarchical list */
    var html = buildNestedList(items);
    tocList.innerHTML = html;

    /* Smooth scroll on click */
    tocList.addEventListener('click', function (e) {
      var link = e.target.closest('a');
      if (!link) return;
      e.preventDefault();
      var targetId = link.getAttribute('href').substring(1);
      var target = document.getElementById(targetId);
      if (target) {
        var offset = 100;
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
        history.replaceState(null, '', '#' + targetId);
      }
    });

    /* Mobile toggle */
    var toggle = document.querySelector(SELECTORS.tocToggle);
    if (toggle) {
      toggle.addEventListener('click', function () {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!expanded));
        tocList.style.display = expanded ? 'none' : 'block';
      });
    }

    /* Scroll spy with IntersectionObserver */
    setupScrollSpy(items, tocList);
  }

  function buildNestedList(items) {
    var minLevel = items[0].level;
    var html = '';

    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var indent = item.level - minLevel;
      html +=
        '<li class="main-article__toc-item main-article__toc-item--l' + indent + '" data-target="' + item.id + '">' +
          '<a href="#' + item.id + '">' + escapeHtml(item.text) + '</a>' +
        '</li>';
    }

    return html;
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  function setupScrollSpy(items, tocList) {
    if (!('IntersectionObserver' in window)) return;

    var tocItems = tocList.querySelectorAll('.main-article__toc-item');
    var idToTocItem = {};
    for (var i = 0; i < tocItems.length; i++) {
      idToTocItem[tocItems[i].getAttribute('data-target')] = tocItems[i];
    }

    var activeId = null;

    var observer = new IntersectionObserver(
      function (entries) {
        /* Find the topmost visible heading */
        var visible = [];
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            visible.push(entry);
          }
        });

        if (visible.length > 0) {
          /* Pick the one closest to the top */
          visible.sort(function (a, b) {
            return a.boundingClientRect.top - b.boundingClientRect.top;
          });
          var newId = visible[0].target.id;
          if (newId !== activeId) {
            if (activeId && idToTocItem[activeId]) {
              idToTocItem[activeId].classList.remove('is-active');
            }
            activeId = newId;
            if (idToTocItem[activeId]) {
              idToTocItem[activeId].classList.add('is-active');
            }
          }
        }
      },
      {
        rootMargin: '-80px 0px -70% 0px',
        threshold: 0
      }
    );

    items.forEach(function (item) {
      observer.observe(item.el);
    });

    /* Activate first item by default */
    if (items.length > 0 && idToTocItem[items[0].id]) {
      idToTocItem[items[0].id].classList.add('is-active');
      activeId = items[0].id;
    }
  }

  /* Run on DOMContentLoaded */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildToc);
  } else {
    buildToc();
  }

  /* Support Shopify section rendering API */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector(SELECTORS.body)) {
      buildToc();
    }
  });
})();
